import { deserialize, object, optional, serializable } from 'serializr';
import { JiraSearchIssueFieldStatusModel } from './jira-search-issue-field-status.model';

export class JiraSearchIssueFieldModel {
  @serializable
  public description: string | null;
  @serializable
  public summary: string;
  @serializable(optional(object(JiraSearchIssueFieldStatusModel)))
  public status: JiraSearchIssueFieldStatusModel;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(JiraSearchIssueFieldModel, input));
  }
}
